import React from "react";
import { LIFESTYLE_IMAGE } from "./constants";

export const LifestyleBanner = () => (
    <section
        className="bg-white pt-4 pb-16 sm:pb-20"
        data-testid="lifestyle-section"
        aria-label="Impacto social"
    >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div
                className="relative overflow-hidden rounded-[2rem] shadow-xl"
                data-testid="lifestyle-banner"
            >
                <img
                    src={LIFESTYLE_IMAGE}
                    alt="Niño falconiano sonriendo, transmitiendo alegría"
                    className="w-full h-64 sm:h-80 lg:h-96 object-cover object-center transition-transform duration-[1200ms] ease-out hover:scale-[1.03]"
                    loading="lazy"
                />
                <div
                    aria-hidden="true"
                    className="absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(90deg, rgba(0,58,105,0.85) 0%, rgba(0,58,105,0.55) 35%, rgba(0,58,105,0.10) 60%, rgba(0,58,105,0) 100%)",
                    }}
                />
                <div className="absolute inset-0 flex items-center">
                    <div className="max-w-xl px-8 sm:px-12 lg:px-16">
                        <span
                            className="text-[11px] font-semibold uppercase tracking-[0.22em]"
                            style={{ color: "var(--lf-gold-light)" }}
                        >
                            Impacto social
                        </span>
                        <h3 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold text-white leading-[1.15]">
                            Alegría que transforma vidas en Falcón.
                        </h3>
                        <div className="mt-5">
                            <div className="lf-gold-divider" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);
